import { gql } from '@apollo/client';

export const ADD_UPDATE_PERSON_WORKPLACES = gql`
  mutation addOrUpdatePersonWorkplaces($input: AddOrUpdatePersonWorkplacesInput) {
    addOrUpdatePersonWorkplaces(input: $input) {
      commandId
    }
  }
`;